import { createAuthContext } from "@react-keycloak/core";
export var reactKeycloakContext = createAuthContext();
//# sourceMappingURL=ReactKeycloakContext.js.map